var chunkToChildrenMap = {
	"5421": [
		4894,
		1311,
		8896,
		6778,
		6798,
		427,
		1873,
		3729,
		7281
	],
	"6369": [
		1873,
		3729,
		7281
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));